<template>
  <div class="blackMarketWrap">
    <div>
      <div class="blackMarket">
        <div class="blackMarketL">
          <img :src="detailData.auctionImg" alt="">
        </div>
        <div class="blackMarketR">
          <div class="tit">{{ detailData.auctionName }}</div>
          <div class="txt" v-if="detailData.status == 0">即将开始</div>
          <div class="txt" v-if="detailData.status == 1">距离结束</div>
          <div class="txt" v-if="detailData.status == 99 || detailData.status == 2">已结束</div>
          <div :class="{ passIn: detailData.status == 2 }">
            <times v-if="detailData.status == 0" :time="detailData.startTime * 1000" :curTime="detailData.currentTime"
              :auctionId="detailData.auctionId"></times>
            <times v-else :time="detailData.endTime * 1000" :curTime="detailData.currentTime"
              :auctionId="detailData.auctionId"></times>
            <div class="priceWrap">
              <template v-if="detailData.status == 99">
                <div class="itm">
                  <label>成交价：</label>
                  <span>{{ detailData.currentPrice }}
                    <el-tooltip class="item" effect="dark" content="积分：充值后获得，可提升VIP等级以及用于积分商城中兑换限量道具。" placement="right">
                      <img :src="require('@/assets/imgs/shop/uesrIcon3.png')" alt="">
                    </el-tooltip>
                  </span>
                </div>
                <div class="itm" v-if="detailData.userNick">
                  <label>中标人：</label>
                  <span>{{ detailData.userNick }}</span>
                </div>
              </template>
              <template v-else-if="detailData.status == 1">
                <div class="itm">
                  <label>当前价：</label>
                  <span>{{ detailData.currentPrice }}
                    <el-tooltip class="item" effect="dark" content="积分：充值后获得，可提升VIP等级以及用于积分商城中兑换限量道具。" placement="right">
                      <img :src="require('@/assets/imgs/shop/uesrIcon3.png')" alt="">
                    </el-tooltip>
                  </span>
                </div>
                <div class="itm" v-if="detailData.userNick">
                  <label>出价人：</label>
                  <span>{{ detailData.userNick }}</span>
                </div>
              </template>
              <template v-else>
                <div class="itm">
                  <label>当前价：</label>
                  <span>{{ detailData.currentPrice }}
                    <el-tooltip class="item" effect="dark" content="积分：充值后获得，可提升VIP等级以及用于积分商城中兑换限量道具。" placement="right">
                      <img :src="require('@/assets/imgs/shop/uesrIcon3.png')" alt="">
                    </el-tooltip>
                  </span>
                </div>
                <div class="itm">
                  <label>起拍价：</label>
                  <span>{{ detailData.initPrice }}
                    <el-tooltip class="item" effect="dark" content="积分：充值后获得，可提升VIP等级以及用于积分商城中兑换限量道具。" placement="right">
                      <img :src="require('@/assets/imgs/shop/uesrIcon3.png')" alt="">
                    </el-tooltip>
                  </span>
                </div>
              </template>
            </div>
          </div>
          <div class="bidPrice">
            <div class="bidPriceBtn" v-if="detailData.status == 0">
              <span class="bidPriceUnit0">即将开始</span>
            </div>
            <div class="bidPriceBtn" v-if="detailData.status == 1">
              <el-input v-model="bidPrice"></el-input>
              <span class="bidPriceUnit" @click="offer">出价</span>
            </div>
            <div class="bidPriceBtn" v-if="detailData.status == 99">
              <span class="bidPriceUnit0">已结束</span>
            </div>
            <div class="bidPriceBtn" v-if="detailData.status == 2">
              <span class="bidPriceUnit0">已流拍</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bidPriceRule">
      <img :src="require('@/assets/imgs/shop/bidPriceRule.png')" alt="">
    </div>
  </div>
</template>

<script>
import times from "@/components/countDown/times";
import axios from "axios";
import Cookies from "js-cookie";
import eventBus from '@/common/bus.js'

import { getAuctionGoodstApi, userBidApi } from "@/api/home/index.js";

export default {
  name: "index",
  components: {
    times
  },
  data() {
    return {
      auctionId: this.$route.query.auctionId,
      bidPrice: 0,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      auctionGoods: [],
      timer: null,
      detailData: {},
    }
  },
  created() {
    this.getDetailData()
    let _this = this
    eventBus.$on('changeStaus', function (data) {
      _this.auctionId = data
      _this.getDetailData()
    })
  },
  methods: {
    async offer() {

      await userBidApi({
        auctionId: this.detailData.auctionId,
        bidPrice: this.bidPrice,
        platForm: 'web',
        userId: Cookies.get('cwsl_userId'),
      }).then(res => {
        if (res.data.state == 200) {
          this.getDetailData(this.detailData)
          this.$message.success(res.data.message)
          eventBus.$emit('resetUserInfo')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    async getDetailData() {
      await getAuctionGoodstApi({
        auctionId: this.auctionId,
        platForm: 'web',
        userId: Cookies.get('cwsl_userId'),
      })
        .then(res => {
          if (res.data.state == 200) {
            this.detailData = res.data.data
            this.bidPrice = res.data.data.currentPrice + 1
          } else {
            this.$message.error(res.data.message)
          }
        })
    },
  },
}
</script>

<style lang="less">
.bidPriceBtn {
  .el-input {
    height: 46px;
    line-height: 46px;
    border: 2px solid #333333;
    border-right: 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;

    input {
      border: none;
      font-size: 30px;
      text-align: center;
      height: 46px;
      line-height: 46px;
      color: #333333;
    }
  }
}
</style>
<style scoped lang="less">
.blackMarketWrap {
  position: relative;
  z-index: 1;

  .blackMarket {
    margin-bottom: 30px;
    overflow: hidden;

    .blackMarketL {
      display: flex;
      justify-content: center;
      align-items: center;
      float: left;
      width: 330px;
      height: 368px;
      border: 4px solid #5472F6;
      box-sizing: border-box;
      background: #fff;

      img {
        width: 100%;
      }
    }

    .blackMarketR {
      float: right;
      width: 350px;
      text-align: center;
      color: #333;

      .tit {
        margin-bottom: 13px;
        font-size: 30px;
        font-weight: 700;
      }

      .txt {
        margin-bottom: 15px;
        font-size: 24px;
        font-weight: 700;
      }

      .priceWrap {
        padding-bottom: 20px;
        text-align: left;
        height: 100px;

        .itm {
          margin-bottom: 30px;

          label {
            font-size: 20px;
          }

          span {
            font-size: 20px;
            color: #5472F6;

            img {
              margin-top: -3px;
              width: 24px;
              vertical-align: middle;
            }
          }
        }
      }

      .passIn {
        background: url("../../../assets/imgs/shop/bidPricePassIn.png") no-repeat bottom right;
      }

      .bidPrice {
        span {
          display: block;
          width: 100%;
          height: 50px;
          line-height: 50px;
          font-size: 24px;
          color: #ffffff;
          cursor: pointer;
          background: #FF586C;
          border-radius: 4px;
        }

        .passInBtn {
          cursor: default;
          background: #979797;
        }

        .bidPriceBtn {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 50px;
          line-height: 50px;
          box-sizing: border-box;

          .bidPriceUnit {
            width: 148px;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            font-size: 24px;
            color: #ffffff;
            cursor: pointer;
            background: #FF586C;
          }

          .bidPriceUnit0 {
            width: 100%;
            border-radius: 4px;
            color: #ffffff;
            background: #333333;
            font-size: 24px;
            cursor: default;
          }
        }
      }
    }
  }

  .bidPriceRule {
    position: absolute;
    right: -355px;
    top: -20px;
  }
}
</style>
